// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__pTA8K","calendarButtons":"ClockData_calendarButtons__1D2F6"};